import { all, fork } from 'redux-saga/effects'
import appSaga from '~/views/app/redux/sagas/index'
import authSaga from '~/views/auth/redux/sagas/index'

export default function* rootSaga() {
  yield all([fork(appSaga),fork(authSaga)])
}
